import { map } from 'lodash';
import ContactPersonEmployment from './ContactPersonEmployment';
import type { IContactPerson } from './ContactPerson.interface';
import ContactPersonDetails from './ContactPersonDetails';
import ContactPersonInformation from './ContactPersonInformation';

export default class ContactPerson implements IContactPerson {
  information: ContactPersonInformation;
  contact: ContactPersonDetails;
  employments: Array<ContactPersonEmployment>;

  static build = (data: IContactPerson) => new ContactPerson(data);
  static blank = () => new ContactPerson();

  /**
   * Constructor
   * @param {IContactPerson} data
   */
  constructor(data?: IContactPerson) {
    this.information = new ContactPersonInformation(data?.information);
    this.contact = new ContactPersonDetails(data?.contact);
    this.employments = map(data?.employments, (obj) => new ContactPersonEmployment(obj));
  }
}
